import { Theme, makeStyles } from '@material-ui/core';
import { CardSizes } from 'componentsV2/cards/grid/card';
import { IconPosition } from '../../enums';

const cornerIconSpace = 10;

export const useStyles = makeStyles<Theme, { size: CardSizes }>(() => ({
  wrapper: {
    height: 270,
    borderRadius: 16,
    padding: 12,
    border: '1px solid #EEF0F2',

    '&:hover #favorite-button': {
      opacity: 1
    }
  },
  info: {
    marginTop: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  img: {
    aspectRatio: '1.34/1',
    objectFit: 'cover',
    objectPosition: 'center',
    width: '100%',
    height: '100%',
    maxHeight: 190,
    borderRadius: 12
  },
  desc: {
    color: '#AFBAC6'
  },
  action: {
    alignSelf: 'flex-end'
  },
  arrow: {
    fontSize: 14
  },
  cornerIcon: {
    position: 'absolute'
  },
  [IconPosition.topRight]: {
    top: cornerIconSpace,
    right: cornerIconSpace
  },
  [IconPosition.topLeft]: {
    top: cornerIconSpace,
    left: cornerIconSpace
  },
  [IconPosition.bottomRight]: {
    bottom: cornerIconSpace,
    right: cornerIconSpace
  },
  [IconPosition.bottomLeft]: {
    bottom: cornerIconSpace,
    left: cornerIconSpace
  }
}));
